export var ApplicationConstants;
(function (ApplicationConstants) {
    ApplicationConstants["cleverScope"] = "read:district_admins, read:districts, read:ell_status, read:frl_status, read:iep_status, read:school_admins, read:schools, read:sections, read:sis, read:student_contacts, read:students, read:teachers, read:user_id";
    ApplicationConstants["pleaseContactSupport"] = "Please contact Imagine Learning Technical Support by telephone at 1-866-457-8776 or by email at support@imaginelearning.com.";
    ApplicationConstants["invalidCodeMessage"] = "The code provided from your LMS has likely already been exchanged. Please go back to your LMS login link to try again with a new code.";
    ApplicationConstants["authenticating"] = "Authenticating ...";
    ApplicationConstants["authenticationFailed"] = "Authentication failed";
    ApplicationConstants["authenticationSuccessful"] = "Authentication successful";
    ApplicationConstants["weAreSyncing"] = "We are syncing";
    ApplicationConstants["credentialsValidated"] = "Credentials validated";
    ApplicationConstants["validatingCredentials"] = "Validating credentials ...";
    ApplicationConstants["detailsNotAvailable"] = "Details not available";
    ApplicationConstants["takingYouToImagineLearning"] = "Taking you to Imagine Learning";
    ApplicationConstants["invalidCodeGiven"] = "Invalid code was given. Unable to authenticate user.";
    ApplicationConstants["parsingValidationResponse"] = "Validation response received. Parsing ...";
    ApplicationConstants["invalidRole"] = "Invalid role: ";
    ApplicationConstants["initiatingSSOLogin"] = "Initiating SSO login ...";
    ApplicationConstants["flagrFailed"] = "Flagr call failed...";
})(ApplicationConstants || (ApplicationConstants = {}));
export var Client;
(function (Client) {
    Client["WebSsoClient"] = "WebSsoClient";
})(Client || (Client = {}));
